import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] flex items-center justify-center",
  role: "progressbar",
  "aria-busy": "true",
  "aria-label": "Loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-white/50" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "relative w-16 h-16 animate-spin text-zbr-primary-500",
  viewBox: "0 0 38 38",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      transform: "translate(1 1)",
      "stroke-width": "2"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        "stroke-opacity": ".25",
        cx: "18",
        cy: "18",
        r: "18"
      }),
      /*#__PURE__*/_createElementVNode("path", { d: "M36 18c0-9.94-8.06-18-18-18" })
    ])
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { storeToRefs } from 'pinia';
import { useLoadingDialogStore } from '@/stores/useLoadingDialogStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingDialog',
  setup(__props) {

const loadingDialog = useLoadingDialogStore();
const { active } = storeToRefs(loadingDialog);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(active))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})